import {useRouter} from 'next/router';
import type {FC} from 'react';
import {FollowCompanyButtonContainer} from './container';

type Props = {
  className?: string;
};
const getCompanyNumberFromQuery = (
  companyId: string | string[] | undefined,
): number | null => {
  if (typeof companyId !== 'string') return null;
  const parsedId = Number(companyId);
  return Number.isNaN(parsedId) ? null : parsedId;
};
export const FollowCompanyButtonValidator: FC<Props> = ({className}) => {
  const router = useRouter();
  const companyId = getCompanyNumberFromQuery(router.query.id);
  if (!companyId) return null;

  return (
    <FollowCompanyButtonContainer className={className} companyId={companyId} />
  );
};
